var _path, _path2, _ellipse, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6277 25.5C19.3404 25.5 24.7555 19.8886 24.7555 13C24.7555 6.11141 19.3404 0.5 12.6277 0.5C5.91504 0.5 0.5 6.11141 0.5 13C0.5 19.8886 5.91504 25.5 12.6277 25.5Z",
    fill: "white",
    stroke: "#DC0546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4163 10.16L12.6483 8.6H13.9683V17H12.2523V10.736L11.2203 11.468L10.4163 10.16Z",
    fill: "#DC0546"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6277,
    cy: 13,
    rx: 11.6277,
    ry: 12,
    fill: "#DC0546"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7942 14.7031C12.5934 14.7031 12.4009 14.6208 12.2589 14.4743C12.1169 14.3278 12.0371 14.129 12.0371 13.9218L12.0371 7.78158C12.0371 7.57437 12.1169 7.37564 12.2589 7.22912C12.4009 7.0826 12.5934 7.00028 12.7942 7.00028C12.995 7.00028 13.1876 7.0826 13.3295 7.22912C13.4715 7.37564 13.5513 7.57437 13.5513 7.78158L13.5513 13.9218C13.5513 14.129 13.4715 14.3278 13.3295 14.4743C13.1876 14.6208 12.995 14.7031 12.7942 14.7031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7941 16.6561C12.1669 16.6561 11.6585 17.1808 11.6585 17.828C11.6585 18.4753 12.1669 19 12.7941 19C13.4213 19 13.9297 18.4753 13.9297 17.828C13.9297 17.1808 13.4213 16.6561 12.7941 16.6561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoError);
export default __webpack_public_path__ + "static/media/info-error.8f546789c7db83759b5d4bf2905959ba.svg";
export { ForwardRef as ReactComponent };